<template>
    <div>
        <!--  <div class="header">
              <div class="select">
                  类型：
                  <el-select v-model="typeValue" placeholder="请选择">
                      <el-option
                              v-for="item in types"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                      </el-option>
                  </el-select>
              </div>
              <el-button type="danger">拒绝</el-button>
              <el-button type="success">同意</el-button>
          </div>-->

        <div class="common-table">
            <el-table v-loading="loading" :data="clubChangePay.beanList" row-key="msgId" height="100%">
                <!--<el-table-column type="selection" width="55"/>-->
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" align="center" prop="userId"/>
                <el-table-column label="用户昵称" align="center" prop="nickname"/>
                <el-table-column label="联系方式" align="center" prop="contact"/>
                <el-table-column label="留言框" align="center" prop="message"/>
                <el-table-column label="申请时间" align="center" prop="createTime"/>
                <el-table-column align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="reject(scope.row.msgId)">拒绝</el-button>
                        <el-button type="success" size="mini" @click="approve(scope.row.msgId)">同意</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination class="common-el-pagination"
                       layout="prev,pager,next,jumper"
                       background
                       :page-size="20"
                       :pager-count="5"
                       :current-page="currentPage"
                       @current-change="getList($event)"
                       :total="clubChangePay.total"/>

    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage: 1
            }
        },
        computed: {
            ...mapState('managementMsg', ['clubChangePay'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('managementMsg', ['getClubChangePayList', 'approveClubChangePay', 'rejectClubChangePay']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getClubChangePayList(page).then(() => {
                    this.loading = false;
                    if(this.currentPage !== 1 && !this.clubChangePay.beanList.length){
                        this.getList(this.currentPage - 1)
                    }
                })
            },
            approve(msgId) {
                this.loading = true;
                this.approveClubChangePay(msgId).then(() => {
                    this.$message.success('申请已批准');
                    this.getList(this.currentPage);
                })
            },
            reject(msgId) {
                this.loading = true;
                this.rejectClubChangePay(msgId).then(() => {
                    this.$message.success('申请已拒绝');
                    this.getList(this.currentPage)
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        display: flex;
    }

    .select {
        flex: 1;
    }

    .el-icon-setting:hover {
        cursor: pointer;
    }
</style>